import React from 'react';
import { Card } from '@codametrix/ui-components';

const AmplifyDeprecated = () => (
  <Card className="content-vacant qa-amplify-deprecated" data-testid="amplify-deprecated">
    <h2>
      <b>Codametrix Amplify is no longer available through Epic.</b>
    </h2>
    <h4>Contact your support representative with questions.</h4>
  </Card>
);

export default AmplifyDeprecated;
